export const CompanyStore = {
    state: {},
    mutations: {},
    actions: {},
    getters: {}
}